import React from "react";
import SchemaFormView from "components/util/schema_form/SchemaForm.view";
import l from "components/util/l"

const VariableSelectorModalView = ({ nodeId, variableOptions, onClickAddReference }) => (
  <div className="card">
    <div className="card-header">
      <h3 className="card-title">{l("Selecciona una variable%SC103")}</h3>
    </div>

    <div className="card-body px-4 pt-5 pb-4">
      {console.log()}
      <SchemaFormView
        schema={[{
          name: "reference",
          type: "VARIABLE",
          label: "Referencia%SC105",
          ...function () {
            // Parse variableOptions keys to camel_case
            const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
            let variableOptionsSchema={}
            for (let variableOption in variableOptions)
              variableOptionsSchema[camelToSnakeCase(variableOption)] = variableOptions[variableOption]
            return variableOptionsSchema
          }()

        }]}
        submitText={l("Agregar referencia%SC104")}
        dataReqs={variableOptions.dataReqs}
        flowId={variableOptions.flowId}
        nodeId={nodeId}
        onSubmit={onClickAddReference}
      />
    </div>
  </div>
)

export default VariableSelectorModalView;